import React, { Component } from 'react';
import "./preloader.css";

function Preloader() {
  return (
    <div className="preloader">

      <div className="preloader-eye">
        <svg viewBox="0 0 80 80" fill="none">
          <path d="M10 40 Q40 10 70 40 Q40 70 10 40Z"
            stroke="#b8860b" strokeWidth="1.5" fill="none"/>
          <circle cx="40" cy="40" r="12"
            stroke="#b8860b" strokeWidth="1.5" fill="none"/>
          <circle cx="40" cy="40" r="5" fill="#b8860b"/>
          <line x1="40" y1="28" x2="40" y2="20"
            stroke="#b8860b" strokeWidth="0.5" opacity="0.4"/>
          <line x1="40" y1="52" x2="40" y2="60"
            stroke="#b8860b" strokeWidth="0.5" opacity="0.4"/>
          <line x1="28" y1="40" x2="20" y2="40"
            stroke="#b8860b" strokeWidth="0.5" opacity="0.4"/>
          <line x1="52" y1="40" x2="60" y2="40"
            stroke="#b8860b" strokeWidth="0.5" opacity="0.4"/>
        </svg>
      </div>

      <div className="preloader-line" />
      <p className="preloader-text">Leonardo da Vinci</p>
      <p className="preloader-sub">1452 — 1519</p>

    </div>
  );
}

export default Preloader;